import { UrlMatchResult, UrlSegment } from '@angular/router';

// Custom URL matcher
export function teslaModelMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  const regex = /^used-tesla-(.*)-for-sale$/;
  const path = segments.map((s) => s.path).join('-');
  const match = path.match(regex);

  if (match) {
    return {
      consumed: segments,
      posParams: {
        model: new UrlSegment(match[1], {}),
      },
    };
  }
  return null;
}
